/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */
import { Report2 } from './report-2';

enum MessageType {
    FIRMWARE_DATA = 0x00,
    FIRMWARE_SIZE = 0x01
}
export class OutputReport2 extends Report2 {
    public static readonly MessageType = MessageType;

    public constructor() {
        super();
    }

    public set type(type: MessageType) {
        this.setUint8(0, type);
    }

    public get type(): number {
        return this.getUint8(0);
    }

    public typeString(): string {
        return MessageType[this.type];
    }

    public set totalBytes(length: number) {
        this.setUint8(1, length);
    }
    public get totalBytes() {
        return this.getUint8(1);
    }
}
